define('models/ecard/ecard_detail',[ "backbone" ], function (Backbone) {

    var EcardDetail = Backbone.Model.extend({
        url: function () {
            return pf.consumerURL + "/eCards/ActivationURL/" + this.GCGUID;
        },
        initialize: function (options) {
            options || (options = {});
            this.GCGUID = options.GCGUID;
            this.TenantId = options.BTI;
            this.VirtualGiftCardId = options.VGCID;
            this.ActivationSpotURL = options.ASURL;
        },
        parse: function (data) {
            var response = {};

            // response.GCGUID = data.GCGUID;
            response.TenantId = data.BTI;
            response.VirtualGiftCardId = data.VGCID;
            response.ActivationSpotURL = data.ASURL;

            return response;
        }
    });

    return EcardDetail;
});
